export const data_tu: any = [
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1165',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1166',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1167',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1168',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1169',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1170',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1171',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1172',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1173',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1174',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1175',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1176',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1177',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1178',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1179',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1180',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1181',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1182',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1183',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1184',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1185',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1186',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1187',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1188',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1189',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1190',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1191',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1192',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1193',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1194',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1195',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1196',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1197',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1198',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1199',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1200',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1201',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1202',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1203',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1204',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1205',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1206',
    'Tủ Xman trưng bày': 'Bạc Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1207',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1208',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1209',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1210',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1211',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1212',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1213',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1214',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1215',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1216',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1217',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1218',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1219',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1220',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1221',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1222',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1223',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1224',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1225',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1226',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1227',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1228',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1229',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1230',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1231',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1232',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1233',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1234',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1235',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1236',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1237',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1238',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1239',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1240',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1241',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1242',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1243',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1244',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1245',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1246',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1247',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 68,
    'SUC_CHUA_TOI_DA_DVTB': 117,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1248',
    'Tủ Xman trưng bày': 'Vàng Style',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0973',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0974',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0975',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0976',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0977',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0978',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0979',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0980',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0981',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0982',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0983',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0984',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0985',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0986',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0987',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0988',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0989',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0990',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0992',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0993',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0994',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0995',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0996',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0997',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0998',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C0999',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1000',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1001',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1002',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1003',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1004',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1005',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1006',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1008',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1009',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1011',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1012',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1013',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1014',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1015',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1016',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1017',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1018',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1019',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1020',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1021',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1022',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1023',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1024',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1025',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1026',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1027',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1028',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1029',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1030',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1031',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1032',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1033',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1034',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1035',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1036',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1037',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1038',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1039',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1040',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1041',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1042',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1043',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1044',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1045',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1046',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1047',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1048',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1049',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1050',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1051',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1052',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1053',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1054',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1055',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1057',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1058',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1059',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1060',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1061',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1062',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1063',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1065',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1066',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1067',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1068',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1069',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1070',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1071',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1072',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1074',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1075',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1076',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1077',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1078',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1079',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1080',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1081',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1082',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1083',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1084',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1085',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1086',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1087',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1088',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1089',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1090',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1091',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1092',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1093',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1094',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1095',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1096',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1097',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1098',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1099',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1100',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1101',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1102',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1103',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1104',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1105',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1106',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1107',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1108',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1109',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1110',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1111',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1112',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1113',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1114',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1115',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1116',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1117',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1118',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1119',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1120',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1121',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1122',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1123',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1124',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1125',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1126',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1127',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1128',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1129',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1130',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1131',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1132',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1133',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1134',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1135',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1136',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1137',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1138',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1139',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1140',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1141',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1142',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1143',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1144',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1145',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1146',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1147',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1148',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1149',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1150',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1151',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1152',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1153',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1154',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1155',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1156',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1157',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1158',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1159',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1160',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1161',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1162',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1163',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1164',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0001',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0002',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0003',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0004',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0006',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0007',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0008',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0009',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0010',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0011',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0012',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0013',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0014',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0015',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0016',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0017',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0018',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0019',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0020',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0021',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0022',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0023',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0024',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0025',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0026',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0027',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0028',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0029',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0030',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0031',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0032',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0033',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0034',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0035',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0036',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0037',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0038',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0039',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0040',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0041',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0042',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0043',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0044',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0045',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0046',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0047',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0048',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0049',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0050',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0052',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0053',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0054',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0055',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0056',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0057',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0058',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0059',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0060',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0061',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0062',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0063',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0064',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0065',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0066',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0067',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0068',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0069',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0070',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0071',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0220',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0072',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0073',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0074',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0075',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0076',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0077',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0078',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0079',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0080',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0081',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0082',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0083',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0084',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0086',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0087',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0088',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0089',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0090',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0091',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0092',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0093',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0094',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0095',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0096',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0097',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0098',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0099',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0100',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0101',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0102',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0103',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0104',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 6,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0105',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0106',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0107',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0108',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0109',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0110',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0111',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0112',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0113',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0114',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0115',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0116',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0117',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0118',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0119',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0120',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0122',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0123',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0124',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0125',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0126',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0127',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0128',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0129',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0130',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0131',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0132',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0133',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0134',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0135',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0136',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0137',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0138',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0139',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0140',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0141',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0142',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0144',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0145',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0146',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0147',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0148',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0149',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0150',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0151',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0152',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0153',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0154',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0155',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0156',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0157',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0158',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0159',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0160',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0161',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0162',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0164',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0165',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0166',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0168',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0169',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0170',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0171',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0172',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0173',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0174',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0175',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0176',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0177',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0178',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0179',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0180',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0181',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0182',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0183',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0184',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0185',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0186',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0187',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0188',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0189',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0190',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0191',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0192',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0193',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0194',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0195',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0197',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0198',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0199',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0200',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0201',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0202',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0203',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0204',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0205',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0206',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0207',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0208',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0209',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0210',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0211',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0212',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0213',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0214',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0215',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0216',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0218',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0219',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0221',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0222',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0223',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0224',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0226',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0227',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0228',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0229',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0230',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0231',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0232',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0233',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0234',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0235',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0236',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0237',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0238',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0239',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0240',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0241',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0242',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0243',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0244',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0245',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0246',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0247',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0248',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0249',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0250',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0251',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0252',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0253',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0254',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0255',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0256',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0257',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0258',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0259',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0260',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0261',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0262',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0263',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0264',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0265',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0266',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0267',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0268',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0269',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0270',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0271',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0272',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0273',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0274',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0275',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0276',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0278',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0279',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0280',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0281',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0282',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0283',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0284',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0285',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0286',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0287',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0288',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0289',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0290',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0292',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0293',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0294',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0295',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0296',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0297',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0298',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0299',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0300',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0301',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0302',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0303',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0304',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0305',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0306',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0307',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0308',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0309',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0310',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0312',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0314',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0315',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0316',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0317',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0318',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0319',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0320',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0321',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0322',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0323',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0324',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0325',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0326',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0327',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0328',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0329',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0330',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0331',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0332',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0333',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0334',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0335',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0336',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0337',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0338',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0339',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0340',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0342',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0343',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0344',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0345',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0346',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0347',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0348',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0349',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0350',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0351',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0352',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0354',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0355',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0356',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0357',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0358',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0359',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0360',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0361',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0362',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0363',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0364',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0365',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0366',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0367',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0368',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0369',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0370',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0373',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0374',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0375',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0376',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0377',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0378',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0379',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0380',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0381',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0382',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0383',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0384',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0385',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0386',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0387',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0388',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0389',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0390',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0391',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0392',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0393',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0394',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0395',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0396',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0397',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0398',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0399',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0400',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0401',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0402',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0403',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0404',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0405',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0406',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0407',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0408',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0409',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0410',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0411',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0412',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0413',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0414',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0415',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0416',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0417',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0418',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0419',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0420',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0421',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0422',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0423',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0424',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0425',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0426',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0428',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0429',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0430',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0431',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0432',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0433',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0434',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0435',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0436',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0437',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0438',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0439',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0440',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0441',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0442',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0443',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0444',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0445',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0446',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0447',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0448',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0449',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0450',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0451',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0452',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0453',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0454',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0455',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0456',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0457',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0458',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0459',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0460',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0461',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0462',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0463',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0464',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0465',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0466',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0467',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0468',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0469',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0470',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0471',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0472',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0473',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0474',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0475',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0476',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0477',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0478',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0480',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0481',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0482',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0483',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0485',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0486',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0487',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0488',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0489',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0490',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0491',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0492',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0493',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0494',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0495',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0496',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0497',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0499',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0500',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0501',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0502',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0503',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0504',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0505',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0506',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0507',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0508',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0509',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0510',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0511',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0512',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0513',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0514',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0515',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0516',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0517',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0518',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0519',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0520',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0521',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0522',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0523',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0524',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0525',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0526',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0527',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0528',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0529',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0530',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0531',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0532',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0533',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0534',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0535',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0536',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0537',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0538',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0539',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0540',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0541',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0542',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0543',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0544',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0545',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0546',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0547',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0548',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0549',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0550',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0551',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0552',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0553',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0554',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0556',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0557',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0558',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0559',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0560',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0561',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0562',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0563',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0564',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0565',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0566',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0567',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0569',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0570',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0571',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0572',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0573',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0574',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0575',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0576',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0577',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0578',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0579',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0580',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0581',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0582',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0584',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0585',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0586',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0587',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0588',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0589',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0590',
    'Tủ Xman trưng bày': 'Dây 24K',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0591',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0592',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0593',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0594',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0595',
    'Tủ Xman trưng bày': 'Bạc Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0596',
    'Tủ Xman trưng bày': 'Vàng Disney',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0597',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0598',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0599',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0600',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0601',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0602',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0603',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0604',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0605',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0606',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0607',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0608',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0609',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0610',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0611',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0612',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0613',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 6,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0614',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0615',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0617',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0619',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0620',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0622',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0623',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0624',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0625',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0626',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0627',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0628',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0629',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0630',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0631',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0632',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0633',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0634',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0635',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0636',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0637',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0638',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0639',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0640',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0641',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0642',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0643',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0644',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0645',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0646',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0647',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0648',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0649',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0650',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0651',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0652',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0653',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0654',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0655',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0656',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0657',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0658',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0659',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0660',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0661',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0662',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0663',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0664',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0665',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0666',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0667',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0668',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0669',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0670',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0671',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0672',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0673',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0674',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0675',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0676',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0677',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0678',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0679',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0680',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0681',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0682',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0683',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0684',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0685',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0686',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0687',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0688',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0689',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0690',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0691',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0692',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0693',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0694',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0695',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0696',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0697',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0698',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0699',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0700',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0701',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0702',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0703',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0704',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0705',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0706',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0707',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0708',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0709',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0710',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0711',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0712',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0713',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0714',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0715',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0716',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0717',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0718',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0719',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0720',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0721',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0722',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0723',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0724',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0725',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0726',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0727',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0728',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0729',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0730',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0731',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0732',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0733',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0734',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0735',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0736',
    'Tủ Xman trưng bày': 'Dây sỉ (6800,6500...)',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0737',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0738',
    'Tủ Xman trưng bày': 'Dây tay',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0739',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0740',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0741',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0742',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0743',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0744',
    'Tủ Xman trưng bày': 'Dây 750',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0745',
    'Tủ Xman trưng bày': 'Dây 416',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0746',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0747',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0748',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0749',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0750',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0751',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0752',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0753',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0754',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0755',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0756',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0757',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0758',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0759',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0760',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0761',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0762',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0763',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0764',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0765',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0766',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0767',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0768',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 100,
    'SUC_CHUA_TOI_DA_DVTB': 200,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0769',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0770',
    'Tủ Xman trưng bày': 'Dây Ý & Dây Platin',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 40,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0771',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0772',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0773',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0774',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0775',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0776',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0777',
    'Tủ Xman trưng bày': 'Nhẫn cưới Kim cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0778',
    'Tủ Xman trưng bày': 'Nhẫn cưới trơn',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0779',
    'Tủ Xman trưng bày': 'Nhẫn cưới ECZ/CZ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0780',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0781',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0782',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0783',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0784',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 6,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0785',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 6,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0786',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0787',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0788',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0789',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0790',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 7,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0791',
    'Tủ Xman trưng bày': 'Trang sức trọng lượng',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0792',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0793',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0794',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0795',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0796',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0797',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0798',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0799',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0800',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0801',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0802',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0803',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0804',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0805',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0806',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0807',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0808',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0809',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0810',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0811',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0812',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0813',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0814',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0815',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0816',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0817',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0818',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0819',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0820',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0821',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0822',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0823',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0824',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0825',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0826',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0827',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0828',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0829',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0830',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0831',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0832',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0833',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0834',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0835',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0836',
    'Tủ Xman trưng bày': 'Hàng sỉ (6800,6500...)',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0837',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0838',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0839',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0840',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0841',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0842',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0843',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0844',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0845',
    'Tủ Xman trưng bày': 'Trang Sức Cz & KGD750/585',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0846',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0847',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0848',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0849',
    'Tủ Xman trưng bày': 'Trang sức Ý & TS Platin',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0850',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0851',
    'Tủ Xman trưng bày': 'Trang Sức Ecz & KGD416',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0852',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0853',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0854',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 20,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0855',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0856',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0857',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0858',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0859',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0861',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0862',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0863',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0864',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0865',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0866',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0867',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0868',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0869',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0870',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0871',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0872',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0873',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0874',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0875',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0876',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0877',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0878',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0879',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0880',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0881',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0882',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0884',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0885',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0886',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0887',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0888',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0889',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0890',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 6,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0891',
    'Tủ Xman trưng bày': 'Vòng kiềng 24k',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 3,
    'SUC_CHUA_TOI_DA_DVTB': 6,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0892',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0893',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0894',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0895',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0896',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0897',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0898',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0899',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0900',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0901',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0902',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0903',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0904',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0905',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0906',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0907',
    'Tủ Xman trưng bày': 'Kim cương rời',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 12,
    'SUC_CHUA_TOI_DA_DVTB': 35,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0908',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0909',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0910',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0911',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0912',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0913',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0914',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0915',
    'Tủ Xman trưng bày': 'Bạc Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0916',
    'Tủ Xman trưng bày': 'Vàng Sanrio',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0917',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0918',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0919',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0920',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0921',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0922',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0923',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0924',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0925',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0926',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0927',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0928',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0929',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0930',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0931',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0932',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0933',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0934',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0935',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0936',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0937',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0938',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0939',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0940',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0941',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0942',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0943',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0944',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C0945',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0946',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C0947',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C0948',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0949',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0950',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C0951',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0952',
    'Tủ Xman trưng bày': 'Charm vàng',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0953',
    'Tủ Xman trưng bày': 'Charm bạc',
    'DVTB': 'Khay',
    'SUC_CHUA_TOI_THIEU_DVTB': 15,
    'SUC_CHUA_TOI_DA_DVTB': 29,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0954',
    'Tủ Xman trưng bày': 'Trang sức Citrine',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0955',
    'Tủ Xman trưng bày': 'Trang sức đá khác',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0956',
    'Tủ Xman trưng bày': 'Trang sức Vỏ',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0957',
    'Tủ Xman trưng bày': 'Trang sức Ruby',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0958',
    'Tủ Xman trưng bày': 'Trang sức Kim Cương',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0959',
    'Tủ Xman trưng bày': 'Trang sức Ngọc trai',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C0960',
    'Tủ Xman trưng bày': 'Trang sức Topaz',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 60,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0961',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0962',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0963',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0964',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0965',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0966',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0967',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0968',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0969',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0970',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0971',
    'Tủ Xman trưng bày': 'Dây bạc',
    'DVTB': 'Cây dây',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C0972',
    'Tủ Xman trưng bày': 'Bạc',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1249',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1250',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1251',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1252',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1253',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1254',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1255',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1256',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1257',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1258',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1259',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1260',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1261',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1262',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1263',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1264',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1265',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1266',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1267',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1268',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1269',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1270',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1271',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1272',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1273',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1274',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1275',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1276',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1277',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1278',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1279',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1280',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1281',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1282',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1283',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'SILVER',
    'Mã tủ': 'C1284',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1285',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1286',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1287',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 50,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'MINI STORE',
    'Mã tủ': 'C1288',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'STYLE',
    'Mã tủ': 'C1289',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1290',
    'Tủ Xman trưng bày': 'Bạc Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1295',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1300',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1309',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1291',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1292',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'DNB',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1297',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1298',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1316',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1301',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'HCM',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1304',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1305',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1306',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MBC',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1311',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1313',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1314',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1323',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'MTG',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1318',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1320',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1321',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'MTY',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1325',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEXT',
    'Mã tủ': 'C1327',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 40,
    'SUC_CHUA_TOI_DA_DVTB': 70,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'NEW CENTER',
    'Mã tủ': 'C1328',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 60,
    'SUC_CHUA_TOI_DA_DVTB': 80,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'CENTER',
    'Mã tủ': 'C1329',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 70,
    'SUC_CHUA_TOI_DA_DVTB': 90,
  },
  {
    'MA_KV': 'TNN',
    'MO_HINH_KINH_DOANH': 'LOW COST',
    'Mã tủ': 'C1332',
    'Tủ Xman trưng bày': 'Vàng Nam Trang',
    'DVTB': 'Tủ',
    'SUC_CHUA_TOI_THIEU_DVTB': 0,
    'SUC_CHUA_TOI_DA_DVTB': 0,
  },
];
